import React, { Component } from 'react';
import { connect } from 'react-redux';
import { smartFetch } from 'skrit-web-framework/utils';

const mapDispatchToProps = dispatch => {
    return {
        cleanState() {
            dispatch({ type: 'CLEAN_STATE' });
        },
        onLogin(props) {
            dispatch({ type: 'CLEAN_STATE' });
            dispatch({ type: 'SET_CONFIG', config: props });
        }
    };
};

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: '',
            pwd: '',
            recover: false
        };
    }

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length) {
            let payload = {
                usuario: match.params.user,
                pwd: match.params.pwd
            };
            this.doLogin(payload);
        } else {
            this.props.cleanState();
        }
    }

    handleSubmit = () => {
        let payload = {
            usuario: this.state.usuario,
            pwd: this.state.pwd
        };
        this.doLogin(payload);
    };

    handleKeyDown = e => {
        if (e.keyCode === 13) {
            this.handleSubmit();
        }
    };

    handleRecover = () => {
        const payload = { usuario: this.state.usuario };
        this.props.toggleIsFetching(true);
        smartFetch('/Login/Recover', {
            method: 'POST',
            body: payload
        }).then(({ body }) => {
            if (body === 'True') {
                this.props.toggleIsFetching(false);
                return this.props.toggleLoginErr(
                    'El correo electrónico con las credenciales se ha enviado con éxito'
                );
            }
            this.props.toggleIsFetching(false);
            return this.props.toggleLoginErr(
                'No se ha podido enviar el correo electrónico'
            );
        });
    };

    doLogin(payload) {
        this.props.toggleLoginErr(null);
        this.props.toggleIsFetching(true);

        smartFetch('/Login/Validar', {
            method: 'POST',
            body: payload
        })
            .then(({ body }) => {
                if (body.ok) {
                    let data = { ...body, isLogged: true, isConnected: false };
                    this.props.onLogin(data);
                    localStorage.setItem('isLogged', 'true');
                    this.props.toggleLoggedIn(true);
                } else {
                    this.props.toggleLoginErr(body.mensajeError);
                }
            })
            .catch(() => {
                this.props.toggleLoginErr(
                    'No se pudo establecer la conexión con el servidor'
                );
            });
    }

    renderRecover() {
        return (
            <div>
                <div className='title'>{'Recuperar tu cuenta'}</div>
                <div className='input-group usuario'>
                    <i className='ms-Icon ms-Icon--Contact' />
                    <input
                        ref={(input) => {
                            this.articuloInput = input;
                        }}
                        className='p-1'
                        type='text'
                        placeholder='Usuario'
                        onKeyDown={this.handleKeyDown}
                        onChange={(e) =>
                            this.setState({ usuario: e.target.value || '' })
                        }
                    />
                </div>
                <div className='d-flex'>
                    <div className='border-right  py-2 pr-4'>
                        <button
                            type='button'
                            className='btn rounded-0 px-4 py-1'
                            style={{ fontSize: '0.8em' }}
                            onClick={this.handleRecover}
                        >
                            {'Recuperar'}
                        </button>
                    </div>
                    <div className='mx-2 my-2'>
                        <button
                            type='button'
                            className='btn recover-pass'
                            onClick={() => {
                                this.setState({ recover: false });
                                this.props.toggleLoginErr(null);
                            }}
                        >
                            {'Iniciar sesion'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderLogin(){
        return (
            <div>
                <div className='title'>Entra en tu cuenta</div>
                <div className='input-group usuario'>
                    <i className='ms-Icon ms-Icon--Contact' />
                    <input
                        className='p-1'
                        type='text'
                        placeholder='Usuario'
                        onKeyDown={this.handleKeyDown}
                        onChange={e =>
                            this.setState({ usuario: e.target.value || '' })
                        }
                        autoFocus
                    />
                </div>
                <div className='input-group password'>
                    <i className='ms-Icon ms-Icon--Lock' />
                    <input
                        className='p-1'
                        type='password'
                        placeholder='Contraseña'
                        onKeyDown={this.handleKeyDown}
                        onChange={e =>
                            this.setState({ pwd: e.target.value || '' })
                        }
                    />
                </div>
                <div className='d-flex'>
                    <div className='pr-4 py-2 border-right'>
                        <button
                            className='btn rounded-0 py-1 px-4'
                            style={{ fontSize: '0.8em' }}
                            onClick={this.handleSubmit}
                        >
                            Entrar
                        </button>
                    </div>
                    <div className='mx-2 my-2'>
                        <button
                            type='button'
                            className='btn recover-pass'
                            onClick={() => {
                                this.setState({ recover: true });
                                this.props.toggleLoginErr(null);
                            }}
                        >
                            {'Recuperar Contraseña'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { recover } = this.state;
        return recover ? this.renderRecover() : this.renderLogin()
    }
}

export default connect(
    null,
    mapDispatchToProps
)(LoginForm);
